<template>
  <div class="container">
    <div class="product_item">
        <p class="title">奖品信息</p>
        <div class="item_wrap">
            <div class="img_box">
             <img src="../../assets/img/product.jpg" alt="">
             </div>
            <dl>
              <dt>水星时尚四件套</dt>
              <dd>福利</dd>
              <dd>数量：1</dd>
            </dl>
          </div>
      </div>
      <div class="prize_flow">
        <p class="title">领取流程</p>
        <ul class="flow_items">
           <li>
             <label>领取信息</label><div class="flow_content">
              <p>1、点击领取地址</p>
              <p>2、输入个人投保信息提交</p>
             </div>
           </li>
           <li>
             <label>领取地址</label><div class="flow_content"><a href="http://baozhunniu.mikecrm.com/lEp7U2o" class="prize_link">http://baozhunniu.mikecrm.com/lEp7U2o</a></div>
           </li>
           <li>
             <label>咨询服务</label><div class="flow_content">
               <p>可扫码关注，微信号baozhunniu</p><img src="http://g.aghcdn.com/aghqr" alt="">
             </div>
           </li>
           <li>
             <label>客服电话</label><div class="flow_content">
               <a href="tel:400-0852-751" class="tel">400-0852-751</a>
               <p class="customer_time"> 周一到周五早9点到晚6点</p>
             </div>
           </li>
        </ul>
      </div>
      <home :ishome=0></home>
  </div>
</template>
<script>
import {
    mapGetters,
    mapActions
} from 'vuex'
import home from '../common/home.vue'
export default {
  data () {
    return {
     	
    }
  },
  components:{
  home

  },
  computed:{   	 	 
  	 ...mapGetters({
    }),

  },
  watch:{

  },
  created(){

  },
  methods:{

  },
  mounted(){}
}
</script>